import { useState } from "react";
import { useAuthStore } from "../../auth/hooks";
import { useForm } from "../../hooks";
import { InputForm, LoadingData, ErrorMessage, MainButton } from "../ui";
import { AuthLayout } from "../layout";
import { useFormMessages } from "../hooks";

const formData = {
  code: "",
};

const formValidations = {
  code: [(value) => value.length > 5, "El codigo debe ser mayor a 5 digitos"],
};

export const ConfirmCodeSection = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    isLoading,
    message,

    // Methods
    startConfirmCode,
  } = useAuthStore();

  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid } = useForm(
    formData,
    formValidations
  );

  const { setFormSubmitted, showErrorMessage, messageText } = useFormMessages({
    message,
    setValidateForm,
  });

  // Funciones ---------------------------------------------//
  const onSendCode = (event) => {
    event.preventDefault();
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      startConfirmCode(formState);
    }
  };

  // Efectos -----------------------------------------------//

  return (
    <AuthLayout>
      <h4 className="text-center">Confirma tu registro</h4>
      <form className="login-form mt-4" onSubmit={onSendCode}>
        <div className="row g-3">
          {/* Formulario estatico */}
          <>
            <div className="col-md-12">
              <InputForm
                label={
                  "Ingresa el código de verificación enviado a tu correo electrónico:"
                }
                type={"text"}
                validation={formValidation.codeValid}
                submit={validateForm}
                name={"code"}
                value={formState.code}
                onInputChange={onInputChange}
              />
            </div>
          </>

          <div className="col-md-12">
            <div className="d-grid">
              <MainButton type={"submit"} disabled={isLoading}>
                Confirmar
              </MainButton>
            </div>
          </div>

          {/* Mensajes */}
          <>
            {isLoading && (
              <div className="col-md-12">
                <LoadingData />
              </div>
            )}
            {showErrorMessage && (
              <div className="col-md-12">
                <ErrorMessage>{messageText}</ErrorMessage>
              </div>
            )}
          </>
        </div>
      </form>
    </AuthLayout>
  );
};
